"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.knowledge.exceeded': 'Osiągnięto limit wpisów wiedzy. Ulepsz swój plan, aby dodać więcej wpisów.',
    'limits.knowledge.limitReached': 'Limit wiedzy: {limit} (ulepsz dla więcej)',
};
